import { decodeId } from './encode-id'

const UUID_PATTERN = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i

// the socket only accepts the plain uuid, but people often copy the base64 graphql id ("VXNlcjo...") instead
export const normaliseUserId = (input: string | null | undefined): string | null => {
  const trimmed = input?.trim()
  if (!trimmed) return null
  if (UUID_PATTERN.test(trimmed)) return trimmed.toLowerCase()
  try {
    const decoded = decodeId(trimmed)
    if (decoded && UUID_PATTERN.test(decoded)) return decoded.toLowerCase()
  } catch {
    // not base64 either
  }
  return null
}

const readParam = (name: string): string | null => new URLSearchParams(window.location.search).get(name)

// ?previewUserId= is a setup link we hand to streamers: it opens the link builder with their id already filled in
export const getPreviewUserIdFromUrl = (): string | null => readParam('previewUserId')

export const isObsBrowserSource = (): boolean => Boolean(window.obsstudio)

export const getUserIdFromUrl = (): string | null => {
  const userId = readParam('userId')
  // an unrecognisable id is still passed through so the failure shows up in the socket and graphql logs
  if (userId) return normaliseUserId(userId) ?? userId
  // a setup link pasted straight into obs would put the builder on stream, run the overlay for that user instead
  if (isObsBrowserSource()) return normaliseUserId(getPreviewUserIdFromUrl())
  return null
}
